<!-- 表格配置 -->
<template>
    <div class="config-box">
        <el-form-item label="主题" label-width="100">
            <el-color-picker
                size="small"
                show-alpha
                v-model="themeColor"
            />
        </el-form-item>
        <el-form-item label="表头内容" label-width="100">
            <FontSet renderType="color, size" v-model="headContent"></FontSet>
        </el-form-item>
        <el-form-item label="表头行高" label-width="100">
            <FontSet renderType="size" v-model="headLineHeight"></FontSet>
        </el-form-item>
        <el-form-item label="单元格内容" label-width="100">
            <FontSet renderType="color, size" v-model="cellContent"></FontSet>
        </el-form-item>
        <el-form-item label="单元格行高" label-width="100">
            <FontSet renderType="size" v-model="cellLineHeight"></FontSet>
        </el-form-item>
    </div>
</template>
  
<script>
import FontSet from './fontSet.vue'

export default {
    name: "sheetConfig",
    data() {
        return {
            themeColor: this.modelValue?.themeColor,
            headContent: this.modelValue?.headContent,
            headLineHeight: this.modelValue?.headLineHeight,
            cellContent: this.modelValue?.cellContent,
            cellLineHeight: this.modelValue?.cellLineHeight,
        }
    },
    props: {
        modelValue: {
            type: Object,
            default: () => {
                return {
                    themeColor: '',
                    headContent: {},
                    headLineHeight: {},
                    cellContent: {},
                    cellLineHeight: {}
                }
            }
        },
    },
    watch: {
        headContent: {
            deep: true,
            handler(val) {
                this.$emit('update:modelValue', {
                    ...this.modelValue,
                    headContent: val,
                })
            },
        },
        headLineHeight: {
            deep: true,
            handler(val) {
                this.$emit('update:modelValue', {
                    ...this.modelValue,
                    headLineHeight: val,
                })
            },
        },
        cellContent: {
            deep: true,
            handler(val) {
                this.$emit('update:modelValue', {
                    ...this.modelValue,
                    cellContent: val,
                })
            },
        },
        cellLineHeight: {
            deep: true,
            handler(val) {
                this.$emit('update:modelValue', {
                    ...this.modelValue,
                    cellLineHeight: val,
                })
            },
        },
        themeColor(val) {
            this.$emit('update:modelValue', {
                ...this.modelValue,
                themeColor: val,
            })
        },
    },
    components: {
        FontSet,
    },
    mounted() {
    },
    methods: {
    }
};
</script>
  
<style lang="scss" scoped>
.config-box {
    padding: 5px 0;
}
</style>